import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, AlertController, ToastController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
//import { Storage } from '@ionic/storage';
import { EmailValidator } from '../../validators/email';
import { DateTimeAdapter } from 'ng-pick-datetime';

import { AdminProvider } from '../../providers/admin/admin';

import * as moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-user-add',
  templateUrl: 'user-add.html',
})
export class UserAddPage {

  myForm: FormGroup;
  loading: Loading;
  public max = new Date();
  constructor(public admin: AdminProvider, dateTimeAdapter: DateTimeAdapter<any>, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public afAuth: AngularFireAuth, public alertCtrl: AlertController, public loadingCtrl: LoadingController, private afs: AngularFirestore, public toastCtrl: ToastController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.myForm = this.formBuilder.group({
      name: ['', Validators.required],
      sex: [''],
      email: ['', [Validators.required, EmailValidator.isValid]],
      email2: ['', [EmailValidator.isValid]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      password2: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      dob: [''],
      company: ['Gepp'],
      ocupation: [''],
      phone: [''],
    });
  }

  ionViewDidLoad() { }

  onSubmit() {
    this.presentLoadingCustom();
    if (this.myForm.value.dob) {
      this.myForm.value.dob = moment(this.myForm.value.dob).format("YYYY-MM-DD");
    }
    this.afAuth.auth.currentUser.getIdToken(true).then((idToken) => {
      let myData = {
        dob: this.myForm.value.dob,
        assignments: 0,
        coach: this.afAuth.auth.currentUser.uid,
        company: this.myForm.value.company,
        email: String(this.myForm.value.email).toLowerCase(),
        email2: String(this.myForm.value.email2).toLowerCase(),
        lastSession: "",
        name: this.myForm.value.name,
        uppercaseName : String(this.myForm.value.name).toLocaleUpperCase(),
        nextSession: "",
        ocupation: this.myForm.value.ocupation,
        phone: this.myForm.value.phone,
        sex: this.myForm.value.sex,
        type: 2,
        status: 1,
        isNewUser: true,
        profile: { downloadURL: 'https://firebasestorage.googleapis.com/v0/b/coachingretirement-bf8e3.appspot.com/o/assets%2Fuserret.jpg?alt=media&token=a54cc3ad-d259-477e-8b7a-72feac02fbe7' }
      }
      ////console.log(myData);
      this.admin.createAccount(idToken, (String(this.myForm.value.password)), myData).toPromise().then((response) => {
        if (response['success'] == true) {
          this.loading.dismiss();
          this.navCtrl.pop();
          this.presentToast('Agregado correctamente');
        } else {
          this.loading.dismiss();
          ////console.error(response);
          this.presentToast('Ha ocurrido un error');
        }
      }).catch(error => {
        this.loading.dismiss();
        ////console.error(error);
        this.presentToast('Ha ocurrido un error');
      });
    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast('Ha ocurrido un error');
    });
  }

  addUserToDb(id: string) {
    this.afs.collection('Users').doc(id).set({
      dob: new Date(this.myForm.value.dob),
      assignments: 0,
      coach: this.afAuth.auth.currentUser.uid,
      company: this.myForm.value.company,
      email: String(this.myForm.value.email).toLowerCase(),
      email2: String(this.myForm.value.email2).toLowerCase(),
      lastSession: "",
      name: this.myForm.value.name,
      nextSession: "",
      ocupation: this.myForm.value.ocupation,
      phone: this.myForm.value.phone,
      sex: this.myForm.value.sex,
      type: 2,
      status: 1,
      isNewUser: true,
      profile: { downloadURL: 'https://firebasestorage.googleapis.com/v0/b/coachingretirement-bf8e3.appspot.com/o/assets%2Fuserret.jpg?alt=media&token=a54cc3ad-d259-477e-8b7a-72feac02fbe7' }
    }).then(res => {
      this.loading.dismiss();
      this.presentToast("Usuario agregado correctamente");
      this.navCtrl.pop();
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

}


// WEBPACK FOOTER //
// ./src/pages/user-add/user-add.ts